import { render, staticRenderFns } from "./helper-box.vue?vue&type=template&id=405e07b6&scoped=true&lang=pug"
import script from "./helper-box.vue?vue&type=script&lang=ts"
export * from "./helper-box.vue?vue&type=script&lang=ts"
import style0 from "./helper-box.vue?vue&type=style&index=0&id=405e07b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e07b6",
  null
  
)

export default component.exports